import { Injectable } from '@angular/core';
import { DocumentMoveAuthTableConfig } from '@app/documents/models/document-move-auth-table-config.model';
import { ICoreAuthorizationDTO, ICoreMemberDTO, IDocumentResponseDTO } from '@core/model';
import { TableColumn } from '@mynexus/mynexus-ui-lib';
import { Observable, map } from 'rxjs';
import { AuthorizationHHService } from './authorization.service';
import { MemberHHService } from './member.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentsMoveHHService {
  constructor(
    private authorizationHHService: AuthorizationHHService,
    private memberHHService: MemberHHService
  ) {}

  getAuthorizationTableConfig(): TableColumn[] {
    return [
      new TableColumn('Authorization Number', 'authorizationNumber'),
      new TableColumn('MemberID', 'memberId'),
      new TableColumn('Member Name', 'memberName'),
      new TableColumn('Effective From', 'effectiveFromDate'),
      new TableColumn('Effective To', 'effectiveToDate'),
      new TableColumn('Auth Level', 'authorizationStatus'),
      new TableColumn('Total Approved Visits', 'totalApproved'),
      new TableColumn('Created On', 'createdOn'),
      new TableColumn('Created By', 'createdBy'),
    ];
  }

  mapAuthorizationTableData(
    authorizationDto: ICoreAuthorizationDTO[],
    memberDto: ICoreMemberDTO
  ): DocumentMoveAuthTableConfig[] {
    return authorizationDto.map((x) => {
      return {
        authorizationNumber: x.authorizationNumber,
        memberId: memberDto?.subscriberNumber,
        memberName: memberDto
          ? `${memberDto.firstName} ${memberDto.lastName}`
          : '',
        effectiveFromDate: x.effectiveFromDate, // formatted differently
        effectiveToDate: x.effectiveToDate, // formatted differently
        authorizationStatus: x.authorizationStatus,
        // totalApprovedVisits isn't even in the model. This may always be '-'.
        totalApproved: '-',
        createdOn: x.createdOn,
        createdBy: x.createdBy,
      };
    });
  }

  // Specially for HH, we dont need 2 requests for auth&member api, but we have to return in a way shared handler works
  getMoveDocumentData(tenantId: string, newAuthorizationNumber: string): Observable<[ICoreAuthorizationDTO, ICoreMemberDTO]> {
    return this.authorizationHHService.getAuthorization(tenantId, newAuthorizationNumber).pipe(
      map(res => {
        if (!res) {
          return [null, null];
        }
        const authDTO = this.authorizationHHService.mapAuthorizationDTO(res['authorization']);
        const memberDTO = this.memberHHService.mapMemberDTO(res['memberDTO']);

        return [authDTO, memberDTO];
      })
    );
  }

  filterDocuments(documents: IDocumentResponseDTO[]): IDocumentResponseDTO[] {
    return documents;
  }
}
